import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function VerifyInvitationReject() {
  const { menu, toggleMobileMenu } = useAppLayout();
  
  const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const navigate = useNavigate();
  const queryClient = useQueryClient();


  const {
    data: detailedFamily,
    isLoading: isDetailedLoading,
    isError: isDetailedError,
  } = useQuery({
    queryKey: ['familyDetails'],
    queryFn: async () => {
      const res = await axios.get(
        `${API_URL}/register-family-details-api`,
        { withCredentials: true }
      );
      return res.data;
    },
    staleTime: 0,
    cacheTime: Infinity,
  });


  const [isSubmitting, setIsSubmitting] = useState(false);

const handleReject = async (e) => {
  e.preventDefault();

  if (isSubmitting) return;

  setIsSubmitting(true);

  try {
    const res = await axios.put(
      `${API_URL}/update-invited-rejection-api`,
      {}, // no body
      {
        withCredentials: true,
      }
    );

    if (res.data.success) {
      toast.success("Rejected invite successfully");

      queryClient.invalidateQueries(['checkInvitation']);

      navigate('/');
    } else {
      toast.error(res.data.message || "Update failed");
    }

  } catch (error) {
    console.error(error);
    toast.error("Something went wrong");
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid'>

            <div className="row justify-content-center">
                        <div className="col-12 col-lg-8 col-xl-7">
                         
            
                                {/* ✅ tighter grid */}
                                <div className="row g-3">
            
            
                                <div
              className="d-flex justify-content-center align-items-center" >
                <div
                className="card  text-center p-5 mt-4 rounded-4"
                style={{ maxWidth: "100%",   }} >
                {/* Warning Icon */}
                <div className="mb-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "70px",
                      height: "70px",
                      backgroundColor: "#ffe6e6",
                    }}
                  >
                     
                    <i className="fa fa-exclamation-triangle text-danger fs-2"></i>
                  </div>
                </div>
            
                {/* Title */}
                <h3 className="fw-bold text-danger">Reject Invitation</h3>
            
                {/* Message */}
                <p className="text-muted mt-3">
                 Once you reject the invitation, you won't be able to join {detailedFamily && (
                 <b>{detailedFamily.family_name} </b> )} unless invited again.
                </p>
                <div className="d-flex justify-content-between mt-3">
                                <Link to='/verify-invitation-info-update' className="btn btn-light border rounded-3 px-3 py-2"
                                disabled={isSubmitting}
                                >
                                No
                                </Link>
            
            
                                <button onClick={handleReject} className="btn rounded-3 px-3 py-2 d-inline-flex align-items-center justify-content-center"
                                   
                                   style={{
                                     minWidth: 120,
                                     background: "linear-gradient(135deg, #74BA54, #2C533D)",
                                     border: "none",
                                     color: "#fff",
                                   }}
                                   disabled={isSubmitting}
                                   >
                               {isSubmitting ? "Processing..." : "Yes, I reject"}
                                </button>
            
            
                                </div>
                </div>
               
            
              </div>
            
            
                        
            
                                  
                                </div>
                                
            
            
            
            
                          <div style={{ height: 8 }} />
                        </div>
                      </div>  
                                    
          </div>
        </div>


 
      
      </div>
    
  );
}

export default VerifyInvitationReject;
